<template>
  <div
    :class="$style['game-slide']"
    :style="`background-image: ${props.gameGradient};`"
    @click="userStore.toGame(gameUrl)"
  >
    <img :src="props.gameImg" />
    <GameInfo
      :game-name="props.gameName"
      :game-icon="props.gameIcon"
      :game-class="props.gameClass"
    />
  </div>
</template>

<script setup lang="ts">
import GameInfo from "./GameInfo.vue";
const userStore = useUserStore();
const props = defineProps<{
  gameName: string;
  gameIcon: string;
  gameClass: string;
  gameImg?: string;
  gameGradient?: string;
  gameUrl: string;
}>();
</script>

<style lang="scss" module>
.game-slide {
  position: relative;
  height: 280px;
  padding: 16px;
  border-radius: 32px;
  background-color: var(--general-underlay-3-lvl) !important;
  overflow: hidden;
  cursor: pointer;
  &:hover,
  &:active {
    img {
      bottom: 6%;
    }
  }
  img {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 249px;
    height: 210px;
    transform: scale(1.15);
    transition: all 0.2s ease-in-out;
  }

  @media screen and (max-width: 900px) {
    height: 215px;
    img {
      width: 190px;
      height: 166px;
    }
  }
  @media screen and (max-width: 600px) {
    height: 172px;
    img {
      width: 150px;
      height: 130px;
    }
  }
}
</style>
